import { createContext } from "react";

const QueryContext = createContext({
  //active selection
  technologies: [],
  setTechnologies: (values) => {},
  countries: [],
  setCountries: (values) => {},
  statuses: [],
  setStatus: (values) => {},

  // other functions
  resetSelection: () => {},
});

export default QueryContext;
